/* eslint-disable */
// prettier-ignore
import { AspidaClient, BasicHeaders, dataToURLString } from 'aspida'
// prettier-ignore
import { Methods as Methods0 } from '.'
// prettier-ignore
import { Methods as Methods1 } from './auth/login'
// prettier-ignore
import { Methods as Methods2 } from './auth/me'
// prettier-ignore
import { Methods as Methods3 } from './auth/reset-password'
// prettier-ignore
import { Methods as Methods4 } from './auth/update-password'
// prettier-ignore
import { Methods as Methods5 } from './brand-skus'
// prettier-ignore
import { Methods as Methods6 } from './brand-skus/suggest'
// prettier-ignore
import { Methods as Methods7 } from './category/child'
// prettier-ignore
import { Methods as Methods8 } from './category/parent'
// prettier-ignore
import { Methods as Methods9 } from './chain-stores'
// prettier-ignore
import { Methods as Methods10 } from './chain-stores/_id@number/receipt-pattern'
// prettier-ignore
import { Methods as Methods11 } from './chain-stores/_id@number/set-receipt-pattern'
// prettier-ignore
import { Methods as Methods12 } from './changed-matcheds'
// prettier-ignore
import { Methods as Methods13 } from './channels'
// prettier-ignore
import { Methods as Methods14 } from './condition'
// prettier-ignore
import { Methods as Methods15 } from './condition/_condition_id@number'
// prettier-ignore
import { Methods as Methods16 } from './gcs/questionnaire-image'
// prettier-ignore
import { Methods as Methods17 } from './items/_id@string'
// prettier-ignore
import { Methods as Methods18 } from './items/new'
// prettier-ignore
import { Methods as Methods19 } from './items/re'
// prettier-ignore
import { Methods as Methods20 } from './logs'
// prettier-ignore
import { Methods as Methods21 } from './logs/logs.csv'
// prettier-ignore
import { Methods as Methods22 } from './logs/new-progresses'
// prettier-ignore
import { Methods as Methods23 } from './logs/progresses'
// prettier-ignore
import { Methods as Methods24 } from './mail-magazines'
// prettier-ignore
import { Methods as Methods25 } from './mail-magazines/_id/logs'
// prettier-ignore
import { Methods as Methods26 } from './mail-magazines/_id@number'
// prettier-ignore
import { Methods as Methods27 } from './mail-magazines/_id@number/count-target'
// prettier-ignore
import { Methods as Methods28 } from './matcheds'
// prettier-ignore
import { Methods as Methods29 } from './matcheds/_id@string'
// prettier-ignore
import { Methods as Methods30 } from './matcheds/by-name'
// prettier-ignore
import { Methods as Methods31 } from './mlogs/sns'
// prettier-ignore
import { Methods as Methods32 } from './monitors'
// prettier-ignore
import { Methods as Methods33 } from './monitors/_id@string'
// prettier-ignore
import { Methods as Methods34 } from './monitors/answer-histories'
// prettier-ignore
import { Methods as Methods35 } from './monitors/internal'
// prettier-ignore
import { Methods as Methods36 } from './monitors/internal/_id@string'
// prettier-ignore
import { Methods as Methods37 } from './monitors/monitors.csv'
// prettier-ignore
import { Methods as Methods38 } from './notices'
// prettier-ignore
import { Methods as Methods39 } from './notices/_id@number'
// prettier-ignore
import { Methods as Methods40 } from './place'
// prettier-ignore
import { Methods as Methods41 } from './qlogs'
// prettier-ignore
import { Methods as Methods42 } from './qlogs/qlogs.csv'
// prettier-ignore
import { Methods as Methods43 } from './question'
// prettier-ignore
import { Methods as Methods44 } from './question/_question_id@number'
// prettier-ignore
import { Methods as Methods45 } from './question-answer/_id@number'
// prettier-ignore
import { Methods as Methods46 } from './question-answer/upload-image'
// prettier-ignore
import { Methods as Methods47 } from './questionnaire'
// prettier-ignore
import { Methods as Methods48 } from './questionnaire/_id@number'
// prettier-ignore
import { Methods as Methods49 } from './questionnaire/_id@number/answers.csv'
// prettier-ignore
import { Methods as Methods50 } from './questionnaire/_id@number/copy'
// prettier-ignore
import { Methods as Methods51 } from './questionnaire/_id@string/_answerId@string'
// prettier-ignore
import { Methods as Methods52 } from './questionnaire/additional-issue/_id@number'
// prettier-ignore
import { Methods as Methods53 } from './questionnaire/count-target/_id@number'
// prettier-ignore
import { Methods as Methods54 } from './questionnaire/fixed/_questionnaireId@string'
// prettier-ignore
import { Methods as Methods55 } from './questionnaire/fixed-preview/_questionnaireId@string'
// prettier-ignore
import { Methods as Methods56 } from './questionnaire/issue/_id@number'
// prettier-ignore
import { Methods as Methods57 } from './questionnaire/preview/_questionnaireId@string'
// prettier-ignore
import { Methods as Methods58 } from './questionnaire/preview-url/_id@number'
// prettier-ignore
import { Methods as Methods59 } from './questionnaire-answer'
// prettier-ignore
import { Methods as Methods60 } from './questionnaire-answer/_id@number'
// prettier-ignore
import { Methods as Methods61 } from './questionnaire-answer/_questionnaireId@string/_answerId@string'
// prettier-ignore
import { Methods as Methods62 } from './questionnaire-answer/internal/_monitorId@string'
// prettier-ignore
import { Methods as Methods63 } from './questionnaire-answer/results-requests'
// prettier-ignore
import { Methods as Methods64 } from './questionnaire-page'
// prettier-ignore
import { Methods as Methods65 } from './questionnaire-page/_page_id@number'
// prettier-ignore
import { Methods as Methods66 } from './receipts'
// prettier-ignore
import { Methods as Methods67 } from './receipts/_id@number'
// prettier-ignore
import { Methods as Methods68 } from './receipts/bigquery.csv'
// prettier-ignore
import { Methods as Methods69 } from './receipts/checkDuplicated'
// prettier-ignore
import { Methods as Methods70 } from './receipts/chobirich/remaind-count'
// prettier-ignore
import { Methods as Methods71 } from './receipts/chobirich/upload-image'
// prettier-ignore
import { Methods as Methods72 } from './receipts/contributers'
// prettier-ignore
import { Methods as Methods73 } from './receipts/contributers.csv'
// prettier-ignore
import { Methods as Methods74 } from './receipts/internal/remained-count/_monitorId@string'
// prettier-ignore
import { Methods as Methods75 } from './receipts/is-existing-image-id/_imageId@string'
// prettier-ignore
import { Methods as Methods76 } from './receipts/mock-questionnaire/_id@string/_questionnaireId@number'
// prettier-ignore
import { Methods as Methods77 } from './receipts/results-requests'
// prettier-ignore
import { Methods as Methods78 } from './receipts/results-requests-by-ids'
// prettier-ignore
import { Methods as Methods79 } from './receipts/snapShot'
// prettier-ignore
import { Methods as Methods80 } from './receipts/summaries'
// prettier-ignore
import { Methods as Methods81 } from './recommend'
// prettier-ignore
import { Methods as Methods82 } from './shops'
// prettier-ignore
import { Methods as Methods83 } from './shops/_id@string'
// prettier-ignore
import { Methods as Methods84 } from './slogs'
// prettier-ignore
import { Methods as Methods85 } from './slogs/slogs.csv'
// prettier-ignore
import { Methods as Methods86 } from './special-offer-receipts'
// prettier-ignore
import { Methods as Methods87 } from './special-offer-receipts/_id@number'
// prettier-ignore
import { Methods as Methods88 } from './special-offer-receipts/internal'
// prettier-ignore
import { Methods as Methods89 } from './special-offer-receipts/internal-by-imported-at'
// prettier-ignore
import { Methods as Methods90 } from './special-offers'
// prettier-ignore
import { Methods as Methods91 } from './special-offers/_id@string'
// prettier-ignore
import { Methods as Methods92 } from './special-offers/internal'
// prettier-ignore
import { Methods as Methods93 } from './users'
// prettier-ignore
import { Methods as Methods94 } from './users/_id@number'

// prettier-ignore
const api = <T>({ baseURL, fetch }: AspidaClient<T>) => {
  const prefix = (baseURL === undefined ? '' : baseURL).replace(/\/$/, '')
  const PATH0 = '/auth/login'
  const PATH1 = '/auth/me'
  const PATH2 = '/auth/reset-password'
  const PATH3 = '/auth/update-password'
  const PATH4 = '/brand-skus'
  const PATH5 = '/brand-skus/suggest'
  const PATH6 = '/category/child'
  const PATH7 = '/category/parent'
  const PATH8 = '/chain-stores'
  const PATH9 = '/receipt-pattern'
  const PATH10 = '/set-receipt-pattern'
  const PATH11 = '/changed-matcheds'
  const PATH12 = '/channels'
  const PATH13 = '/condition'
  const PATH14 = '/gcs/questionnaire-image'
  const PATH15 = '/items'
  const PATH16 = '/items/new'
  const PATH17 = '/items/re'
  const PATH18 = '/logs'
  const PATH19 = '/logs/logs.csv'
  const PATH20 = '/logs/new-progresses'
  const PATH21 = '/logs/progresses'
  const PATH22 = '/mail-magazines'
  const PATH23 = '/count-target'
  const PATH24 = '/matcheds'
  const PATH25 = '/matcheds/by-name'
  const PATH26 = '/mlogs/sns'
  const PATH27 = '/monitors'
  const PATH28 = '/monitors/answer-histories'
  const PATH29 = '/monitors/internal'
  const PATH30 = '/monitors/monitors.csv'
  const PATH31 = '/notices'
  const PATH32 = '/place'
  const PATH33 = '/qlogs'
  const PATH34 = '/qlogs/qlogs.csv'
  const PATH35 = '/question'
  const PATH36 = '/question-answer'
  const PATH37 = '/question-answer/upload-image'
  const PATH38 = '/questionnaire'
  const PATH39 = '/answers.csv'
  const PATH40 = '/copy'
  const PATH41 = '/questionnaire/additional-issue'
  const PATH42 = '/questionnaire/count-target'
  const PATH43 = '/questionnaire/fixed'
  const PATH44 = '/questionnaire/fixed-preview'
  const PATH45 = '/questionnaire/issue'
  const PATH46 = '/questionnaire/preview'
  const PATH47 = '/questionnaire/preview-url'
  const PATH48 = '/questionnaire-answer'
  const PATH49 = '/questionnaire-answer/internal'
  const PATH50 = '/questionnaire-answer/results-requests'
  const PATH51 = '/questionnaire-page'
  const PATH52 = '/receipts'
  const PATH53 = '/receipts/bigquery.csv'
  const PATH54 = '/receipts/checkDuplicated'
  const PATH55 = '/receipts/chobirich/remaind-count'
  const PATH56 = '/receipts/chobirich/upload-image'
  const PATH57 = '/receipts/contributers'
  const PATH58 = '/receipts/contributers.csv'
  const PATH59 = '/receipts/internal/remained-count'
  const PATH60 = '/receipts/is-existing-image-id'
  const PATH61 = '/receipts/mock-questionnaire'
  const PATH62 = '/receipts/results-requests'
  const PATH63 = '/receipts/results-requests-by-ids'
  const PATH64 = '/receipts/snapShot'
  const PATH65 = '/receipts/summaries'
  const PATH66 = '/recommend'
  const PATH67 = '/shops'
  const PATH68 = '/slogs'
  const PATH69 = '/slogs/slogs.csv'
  const PATH70 = '/special-offer-receipts'
  const PATH71 = '/special-offer-receipts/internal'
  const PATH72 = '/special-offer-receipts/internal-by-imported-at'
  const PATH73 = '/special-offers'
  const PATH74 = '/special-offers/internal'
  const PATH75 = '/users'
  const GET = 'GET'
  const POST = 'POST'
  const PUT = 'PUT'
  const DELETE = 'DELETE'

  return {
    auth: {
      login: {
        post: (option: { body: Methods1['post']['reqBody'], config?: T }) =>
          fetch<Methods1['post']['resBody'], BasicHeaders, Methods1['post']['status']>(prefix, PATH0, POST, option).json(),
        $post: (option: { body: Methods1['post']['reqBody'], config?: T }) =>
          fetch<Methods1['post']['resBody'], BasicHeaders, Methods1['post']['status']>(prefix, PATH0, POST, option).json().then(r => r.body),
        $path: () => `${prefix}${PATH0}`
      },
      me: {
        get: (option?: { config?: T }) =>
          fetch<Methods2['get']['resBody'], BasicHeaders, Methods2['get']['status']>(prefix, PATH1, GET, option).json(),
        $get: (option?: { config?: T }) =>
          fetch<Methods2['get']['resBody'], BasicHeaders, Methods2['get']['status']>(prefix, PATH1, GET, option).json().then(r => r.body),
        $path: () => `${prefix}${PATH1}`
      },
      reset_password: {
        put: (option: { body: Methods3['put']['reqBody'], config?: T }) =>
          fetch<Methods3['put']['resBody'], BasicHeaders, Methods3['put']['status']>(prefix, PATH2, PUT, option).text(),
        $put: (option: { body: Methods3['put']['reqBody'], config?: T }) =>
          fetch<Methods3['put']['resBody'], BasicHeaders, Methods3['put']['status']>(prefix, PATH2, PUT, option).text().then(r => r.body),
        $path: () => `${prefix}${PATH2}`
      },
      update_password: {
        put: (option?: { config?: T }) =>
          fetch<Methods4['put']['resBody'], BasicHeaders, Methods4['put']['status']>(prefix, PATH3, PUT, option).json(),
        $put: (option?: { config?: T }) =>
          fetch<Methods4['put']['resBody'], BasicHeaders, Methods4['put']['status']>(prefix, PATH3, PUT, option).json().then(r => r.body),
        $path: () => `${prefix}${PATH3}`
      }
    },
    brand_skus: {
      suggest: {
        get: (option?: { query?: Methods6['get']['query'], config?: T }) =>
          fetch<Methods6['get']['resBody'], BasicHeaders, Methods6['get']['status']>(prefix, PATH5, GET, option).json(),
        $get: (option?: { query?: Methods6['get']['query'], config?: T }) =>
          fetch<Methods6['get']['resBody'], BasicHeaders, Methods6['get']['status']>(prefix, PATH5, GET, option).json().then(r => r.body),
        $path: (option?: { method?: 'get'; query: Methods6['get']['query'] }) =>
          `${prefix}${PATH5}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
      },
      get: (option?: { query?: Methods5['get']['query'], config?: T }) =>
        fetch<Methods5['get']['resBody'], BasicHeaders, Methods5['get']['status']>(prefix, PATH4, GET, option).json(),
      $get: (option?: { query?: Methods5['get']['query'], config?: T }) =>
        fetch<Methods5['get']['resBody'], BasicHeaders, Methods5['get']['status']>(prefix, PATH4, GET, option).json().then(r => r.body),
      $path: (option?: { method?: 'get'; query: Methods5['get']['query'] }) =>
        `${prefix}${PATH4}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
    },
    category: {
      child: {
        get: (option?: { query?: Methods7['get']['query'], config?: T }) =>
          fetch<Methods7['get']['resBody'], BasicHeaders, Methods7['get']['status']>(prefix, PATH6, GET, option).json(),
        $get: (option?: { query?: Methods7['get']['query'], config?: T }) =>
          fetch<Methods7['get']['resBody'], BasicHeaders, Methods7['get']['status']>(prefix, PATH6, GET, option).json().then(r => r.body),
        $path: (option?: { method?: 'get'; query: Methods7['get']['query'] }) =>
          `${prefix}${PATH6}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
      },
      parent: {
        get: (option?: { config?: T }) =>
          fetch<Methods8['get']['resBody'], BasicHeaders, Methods8['get']['status']>(prefix, PATH7, GET, option).json(),
        $get: (option?: { config?: T }) =>
          fetch<Methods8['get']['resBody'], BasicHeaders, Methods8['get']['status']>(prefix, PATH7, GET, option).json().then(r => r.body),
        $path: () => `${prefix}${PATH7}`
      }
    },
    chain_stores: {
      _id: (val1: number) => {
        const prefix1 = `${PATH8}/${val1}`

        return {
          receipt_pattern: {
            get: (option?: { config?: T }) =>
              fetch<Methods10['get']['resBody'], BasicHeaders, Methods10['get']['status']>(prefix, `${prefix1}${PATH9}`, GET, option).json(),
            $get: (option?: { config?: T }) =>
              fetch<Methods10['get']['resBody'], BasicHeaders, Methods10['get']['status']>(prefix, `${prefix1}${PATH9}`, GET, option).json().then(r => r.body),
            $path: () => `${prefix}${prefix1}${PATH9}`
          },
          set_receipt_pattern: {
            get: (option?: { config?: T }) =>
              fetch<Methods11['get']['resBody'], BasicHeaders, Methods11['get']['status']>(prefix, `${prefix1}${PATH10}`, GET, option).json(),
            $get: (option?: { config?: T }) =>
              fetch<Methods11['get']['resBody'], BasicHeaders, Methods11['get']['status']>(prefix, `${prefix1}${PATH10}`, GET, option).json().then(r => r.body),
            $path: () => `${prefix}${prefix1}${PATH10}`
          }
        }
      },
      get: (option?: { query?: Methods9['get']['query'], config?: T }) =>
        fetch<Methods9['get']['resBody'], BasicHeaders, Methods9['get']['status']>(prefix, PATH8, GET, option).json(),
      $get: (option?: { query?: Methods9['get']['query'], config?: T }) =>
        fetch<Methods9['get']['resBody'], BasicHeaders, Methods9['get']['status']>(prefix, PATH8, GET, option).json().then(r => r.body),
      $path: (option?: { method?: 'get'; query: Methods9['get']['query'] }) =>
        `${prefix}${PATH8}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
    },
    changed_matcheds: {
      post: (option: { body: Methods12['post']['reqBody'], config?: T }) =>
        fetch<Methods12['post']['resBody'], BasicHeaders, Methods12['post']['status']>(prefix, PATH11, POST, option).json(),
      $post: (option: { body: Methods12['post']['reqBody'], config?: T }) =>
        fetch<Methods12['post']['resBody'], BasicHeaders, Methods12['post']['status']>(prefix, PATH11, POST, option).json().then(r => r.body),
      $path: () => `${prefix}${PATH11}`
    },
    channels: {
      get: (option?: { config?: T }) =>
        fetch<Methods13['get']['resBody'], BasicHeaders, Methods13['get']['status']>(prefix, PATH12, GET, option).json(),
      $get: (option?: { config?: T }) =>
        fetch<Methods13['get']['resBody'], BasicHeaders, Methods13['get']['status']>(prefix, PATH12, GET, option).json().then(r => r.body),
      $path: () => `${prefix}${PATH12}`
    },
    condition: {
      _condition_id: (val1: number) => {
        const prefix1 = `${PATH13}/${val1}`

        return {
          put: (option: { body: Methods15['put']['reqBody'], config?: T }) =>
            fetch<Methods15['put']['resBody'], BasicHeaders, Methods15['put']['status']>(prefix, prefix1, PUT, option).json(),
          $put: (option: { body: Methods15['put']['reqBody'], config?: T }) =>
            fetch<Methods15['put']['resBody'], BasicHeaders, Methods15['put']['status']>(prefix, prefix1, PUT, option).json().then(r => r.body),
          delete: (option?: { config?: T }) =>
            fetch<Methods15['delete']['resBody'], BasicHeaders, Methods15['delete']['status']>(prefix, prefix1, DELETE, option).json(),
          $delete: (option?: { config?: T }) =>
            fetch<Methods15['delete']['resBody'], BasicHeaders, Methods15['delete']['status']>(prefix, prefix1, DELETE, option).json().then(r => r.body),
          $path: () => `${prefix}${prefix1}`
        }
      },
      get: (option: { query: Methods14['get']['query'], config?: T }) =>
        fetch<Methods14['get']['resBody'], BasicHeaders, Methods14['get']['status']>(prefix, PATH13, GET, option).json(),
      $get: (option: { query: Methods14['get']['query'], config?: T }) =>
        fetch<Methods14['get']['resBody'], BasicHeaders, Methods14['get']['status']>(prefix, PATH13, GET, option).json().then(r => r.body),
      post: (option: { body: Methods14['post']['reqBody'], config?: T }) =>
        fetch<Methods14['post']['resBody'], BasicHeaders, Methods14['post']['status']>(prefix, PATH13, POST, option).json(),
      $post: (option: { body: Methods14['post']['reqBody'], config?: T }) =>
        fetch<Methods14['post']['resBody'], BasicHeaders, Methods14['post']['status']>(prefix, PATH13, POST, option).json().then(r => r.body),
      $path: (option?: { method?: 'get'; query: Methods14['get']['query'] }) =>
        `${prefix}${PATH13}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
    },
    gcs: {
      questionnaire_image: {
        post: (option: { body: Methods16['post']['reqBody'], config?: T }) =>
          fetch<Methods16['post']['resBody'], BasicHeaders, Methods16['post']['status']>(prefix, PATH14, POST, option, 'FormData').text(),
        $post: (option: { body: Methods16['post']['reqBody'], config?: T }) =>
          fetch<Methods16['post']['resBody'], BasicHeaders, Methods16['post']['status']>(prefix, PATH14, POST, option, 'FormData').text().then(r => r.body),
        $path: () => `${prefix}${PATH14}`
      }
    },
    items: {
      _id: (val1: string) => {
        const prefix1 = `${PATH15}/${val1}`

        return {
          get: (option?: { config?: T }) =>
            fetch<Methods17['get']['resBody'], BasicHeaders, Methods17['get']['status']>(prefix, prefix1, GET, option).json(),
          $get: (option?: { config?: T }) =>
            fetch<Methods17['get']['resBody'], BasicHeaders, Methods17['get']['status']>(prefix, prefix1, GET, option).json().then(r => r.body),
          put: (option: { body: Methods17['put']['reqBody'], config?: T }) =>
            fetch<Methods17['put']['resBody'], BasicHeaders, Methods17['put']['status']>(prefix, prefix1, PUT, option).json(),
          $put: (option: { body: Methods17['put']['reqBody'], config?: T }) =>
            fetch<Methods17['put']['resBody'], BasicHeaders, Methods17['put']['status']>(prefix, prefix1, PUT, option).json().then(r => r.body),
          delete: (option?: { config?: T }) =>
            fetch<Methods17['delete']['resBody'], BasicHeaders, Methods17['delete']['status']>(prefix, prefix1, DELETE, option).json(),
          $delete: (option?: { config?: T }) =>
            fetch<Methods17['delete']['resBody'], BasicHeaders, Methods17['delete']['status']>(prefix, prefix1, DELETE, option).json().then(r => r.body),
          $path: () => `${prefix}${prefix1}`
        }
      },
      new: {
        get: (option: { query: Methods18['get']['query'], config?: T }) =>
          fetch<Methods18['get']['resBody'], BasicHeaders, Methods18['get']['status']>(prefix, PATH16, GET, option).json(),
        $get: (option: { query: Methods18['get']['query'], config?: T }) =>
          fetch<Methods18['get']['resBody'], BasicHeaders, Methods18['get']['status']>(prefix, PATH16, GET, option).json().then(r => r.body),
        $path: (option?: { method?: 'get'; query: Methods18['get']['query'] }) =>
          `${prefix}${PATH16}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
      },
      re: {
        get: (option: { query: Methods19['get']['query'], config?: T }) =>
          fetch<Methods19['get']['resBody'], BasicHeaders, Methods19['get']['status']>(prefix, PATH17, GET, option).json(),
        $get: (option: { query: Methods19['get']['query'], config?: T }) =>
          fetch<Methods19['get']['resBody'], BasicHeaders, Methods19['get']['status']>(prefix, PATH17, GET, option).json().then(r => r.body),
        $path: (option?: { method?: 'get'; query: Methods19['get']['query'] }) =>
          `${prefix}${PATH17}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
      }
    },
    logs: {
      logs_csv: {
        get: (option?: { query?: Methods21['get']['query'], config?: T }) =>
          fetch<void, BasicHeaders, Methods21['get']['status']>(prefix, PATH19, GET, option).send(),
        $get: (option?: { query?: Methods21['get']['query'], config?: T }) =>
          fetch<void, BasicHeaders, Methods21['get']['status']>(prefix, PATH19, GET, option).send().then(r => r.body),
        $path: (option?: { method?: 'get'; query: Methods21['get']['query'] }) =>
          `${prefix}${PATH19}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
      },
      new_progresses: {
        get: (option: { query: Methods22['get']['query'], config?: T }) =>
          fetch<Methods22['get']['resBody'], BasicHeaders, Methods22['get']['status']>(prefix, PATH20, GET, option).json(),
        $get: (option: { query: Methods22['get']['query'], config?: T }) =>
          fetch<Methods22['get']['resBody'], BasicHeaders, Methods22['get']['status']>(prefix, PATH20, GET, option).json().then(r => r.body),
        $path: (option?: { method?: 'get'; query: Methods22['get']['query'] }) =>
          `${prefix}${PATH20}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
      },
      progresses: {
        get: (option: { query: Methods23['get']['query'], config?: T }) =>
          fetch<Methods23['get']['resBody'], BasicHeaders, Methods23['get']['status']>(prefix, PATH21, GET, option).json(),
        $get: (option: { query: Methods23['get']['query'], config?: T }) =>
          fetch<Methods23['get']['resBody'], BasicHeaders, Methods23['get']['status']>(prefix, PATH21, GET, option).json().then(r => r.body),
        $path: (option?: { method?: 'get'; query: Methods23['get']['query'] }) =>
          `${prefix}${PATH21}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
      },
      post: (option: { body: Methods20['post']['reqBody'], config?: T }) =>
        fetch<Methods20['post']['resBody'], BasicHeaders, Methods20['post']['status']>(prefix, PATH18, POST, option).json(),
      $post: (option: { body: Methods20['post']['reqBody'], config?: T }) =>
        fetch<Methods20['post']['resBody'], BasicHeaders, Methods20['post']['status']>(prefix, PATH18, POST, option).json().then(r => r.body),
      get: (option?: { query?: Methods20['get']['query'], config?: T }) =>
        fetch<Methods20['get']['resBody'], BasicHeaders, Methods20['get']['status']>(prefix, PATH18, GET, option).json(),
      $get: (option?: { query?: Methods20['get']['query'], config?: T }) =>
        fetch<Methods20['get']['resBody'], BasicHeaders, Methods20['get']['status']>(prefix, PATH18, GET, option).json().then(r => r.body),
      $path: (option?: { method?: 'get'; query: Methods20['get']['query'] }) =>
        `${prefix}${PATH18}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
    },
    mail_magazines: {
      _id: (val1: number | string) => {
        const prefix1 = `${PATH22}/${val1}`

        return {
          logs: {
            get: (option: { query: Methods25['get']['query'], config?: T }) =>
              fetch<Methods25['get']['resBody'], BasicHeaders, Methods25['get']['status']>(prefix, `${prefix1}${PATH18}`, GET, option).json(),
            $get: (option: { query: Methods25['get']['query'], config?: T }) =>
              fetch<Methods25['get']['resBody'], BasicHeaders, Methods25['get']['status']>(prefix, `${prefix1}${PATH18}`, GET, option).json().then(r => r.body),
            $path: (option?: { method?: 'get'; query: Methods25['get']['query'] }) =>
              `${prefix}${prefix1}${PATH18}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
          }
        }
      },
      _id_number: (val1: number) => {
        const prefix1 = `${PATH22}/${val1}`

        return {
          count_target: {
            get: (option?: { config?: T }) =>
              fetch<Methods27['get']['resBody'], BasicHeaders, Methods27['get']['status']>(prefix, `${prefix1}${PATH23}`, GET, option).json(),
            $get: (option?: { config?: T }) =>
              fetch<Methods27['get']['resBody'], BasicHeaders, Methods27['get']['status']>(prefix, `${prefix1}${PATH23}`, GET, option).json().then(r => r.body),
            $path: () => `${prefix}${prefix1}${PATH23}`
          },
          get: (option?: { config?: T }) =>
            fetch<Methods26['get']['resBody'], BasicHeaders, Methods26['get']['status']>(prefix, prefix1, GET, option).json(),
          $get: (option?: { config?: T }) =>
            fetch<Methods26['get']['resBody'], BasicHeaders, Methods26['get']['status']>(prefix, prefix1, GET, option).json().then(r => r.body),
          put: (option: { body: Methods26['put']['reqBody'], config?: T }) =>
            fetch<Methods26['put']['resBody'], BasicHeaders, Methods26['put']['status']>(prefix, prefix1, PUT, option).json(),
          $put: (option: { body: Methods26['put']['reqBody'], config?: T }) =>
            fetch<Methods26['put']['resBody'], BasicHeaders, Methods26['put']['status']>(prefix, prefix1, PUT, option).json().then(r => r.body),
          delete: (option?: { config?: T }) =>
            fetch<Methods26['delete']['resBody'], BasicHeaders, Methods26['delete']['status']>(prefix, prefix1, DELETE, option).json(),
          $delete: (option?: { config?: T }) =>
            fetch<Methods26['delete']['resBody'], BasicHeaders, Methods26['delete']['status']>(prefix, prefix1, DELETE, option).json().then(r => r.body),
          $path: () => `${prefix}${prefix1}`
        }
      },
      post: (option: { body: Methods24['post']['reqBody'], config?: T }) =>
        fetch<Methods24['post']['resBody'], BasicHeaders, Methods24['post']['status']>(prefix, PATH22, POST, option).json(),
      $post: (option: { body: Methods24['post']['reqBody'], config?: T }) =>
        fetch<Methods24['post']['resBody'], BasicHeaders, Methods24['post']['status']>(prefix, PATH22, POST, option).json().then(r => r.body),
      get: (option?: { query?: Methods24['get']['query'], config?: T }) =>
        fetch<Methods24['get']['resBody'], BasicHeaders, Methods24['get']['status']>(prefix, PATH22, GET, option).json(),
      $get: (option?: { query?: Methods24['get']['query'], config?: T }) =>
        fetch<Methods24['get']['resBody'], BasicHeaders, Methods24['get']['status']>(prefix, PATH22, GET, option).json().then(r => r.body),
      $path: (option?: { method?: 'get'; query: Methods24['get']['query'] }) =>
        `${prefix}${PATH22}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
    },
    matcheds: {
      _id: (val1: string) => {
        const prefix1 = `${PATH24}/${val1}`

        return {
          put: (option: { body: Methods29['put']['reqBody'], config?: T }) =>
            fetch<Methods29['put']['resBody'], BasicHeaders, Methods29['put']['status']>(prefix, prefix1, PUT, option).json(),
          $put: (option: { body: Methods29['put']['reqBody'], config?: T }) =>
            fetch<Methods29['put']['resBody'], BasicHeaders, Methods29['put']['status']>(prefix, prefix1, PUT, option).json().then(r => r.body),
          delete: (option?: { config?: T }) =>
            fetch<void, BasicHeaders, Methods29['delete']['status']>(prefix, prefix1, DELETE, option).send(),
          $delete: (option?: { config?: T }) =>
            fetch<void, BasicHeaders, Methods29['delete']['status']>(prefix, prefix1, DELETE, option).send().then(r => r.body),
          $path: () => `${prefix}${prefix1}`
        }
      },
      by_name: {
        put: (option: { body: Methods30['put']['reqBody'], query: Methods30['put']['query'], config?: T }) =>
          fetch<void, BasicHeaders, Methods30['put']['status']>(prefix, PATH25, PUT, option).send(),
        $put: (option: { body: Methods30['put']['reqBody'], query: Methods30['put']['query'], config?: T }) =>
          fetch<void, BasicHeaders, Methods30['put']['status']>(prefix, PATH25, PUT, option).send().then(r => r.body),
        delete: (option: { query: Methods30['delete']['query'], config?: T }) =>
          fetch<void, BasicHeaders, Methods30['delete']['status']>(prefix, PATH25, DELETE, option).send(),
        $delete: (option: { query: Methods30['delete']['query'], config?: T }) =>
          fetch<void, BasicHeaders, Methods30['delete']['status']>(prefix, PATH25, DELETE, option).send().then(r => r.body),
        $path: (option?: { method: 'put'; query: Methods30['put']['query'] } | { method: 'delete'; query: Methods30['delete']['query'] }) =>
          `${prefix}${PATH25}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
      },
      get: (option?: { query?: Methods28['get']['query'], config?: T }) =>
        fetch<Methods28['get']['resBody'], BasicHeaders, Methods28['get']['status']>(prefix, PATH24, GET, option).json(),
      $get: (option?: { query?: Methods28['get']['query'], config?: T }) =>
        fetch<Methods28['get']['resBody'], BasicHeaders, Methods28['get']['status']>(prefix, PATH24, GET, option).json().then(r => r.body),
      $path: (option?: { method?: 'get'; query: Methods28['get']['query'] }) =>
        `${prefix}${PATH24}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
    },
    mlogs: {
      sns: {
        post: (option?: { config?: T }) =>
          fetch<Methods31['post']['resBody'], BasicHeaders, Methods31['post']['status']>(prefix, PATH26, POST, option).text(),
        $post: (option?: { config?: T }) =>
          fetch<Methods31['post']['resBody'], BasicHeaders, Methods31['post']['status']>(prefix, PATH26, POST, option).text().then(r => r.body),
        $path: () => `${prefix}${PATH26}`
      }
    },
    monitors: {
      _id: (val1: string) => {
        const prefix1 = `${PATH27}/${val1}`

        return {
          get: (option?: { config?: T }) =>
            fetch<Methods33['get']['resBody'], BasicHeaders, Methods33['get']['status']>(prefix, prefix1, GET, option).json(),
          $get: (option?: { config?: T }) =>
            fetch<Methods33['get']['resBody'], BasicHeaders, Methods33['get']['status']>(prefix, prefix1, GET, option).json().then(r => r.body),
          put: (option: { body: Methods33['put']['reqBody'], config?: T }) =>
            fetch<Methods33['put']['resBody'], BasicHeaders, Methods33['put']['status']>(prefix, prefix1, PUT, option).json(),
          $put: (option: { body: Methods33['put']['reqBody'], config?: T }) =>
            fetch<Methods33['put']['resBody'], BasicHeaders, Methods33['put']['status']>(prefix, prefix1, PUT, option).json().then(r => r.body),
          delete: (option?: { config?: T }) =>
            fetch<Methods33['delete']['resBody'], BasicHeaders, Methods33['delete']['status']>(prefix, prefix1, DELETE, option).json(),
          $delete: (option?: { config?: T }) =>
            fetch<Methods33['delete']['resBody'], BasicHeaders, Methods33['delete']['status']>(prefix, prefix1, DELETE, option).json().then(r => r.body),
          $path: () => `${prefix}${prefix1}`
        }
      },
      answer_histories: {
        get: (option?: { query?: Methods34['get']['query'], config?: T }) =>
          fetch<Methods34['get']['resBody'], BasicHeaders, Methods34['get']['status']>(prefix, PATH28, GET, option).json(),
        $get: (option?: { query?: Methods34['get']['query'], config?: T }) =>
          fetch<Methods34['get']['resBody'], BasicHeaders, Methods34['get']['status']>(prefix, PATH28, GET, option).json().then(r => r.body),
        $path: (option?: { method?: 'get'; query: Methods34['get']['query'] }) =>
          `${prefix}${PATH28}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
      },
      internal: {
        _id: (val2: string) => {
          const prefix2 = `${PATH29}/${val2}`

          return {
            post: (option: { body: Methods36['post']['reqBody'], config?: T }) =>
              fetch<Methods36['post']['resBody'], BasicHeaders, Methods36['post']['status']>(prefix, prefix2, POST, option).json(),
            $post: (option: { body: Methods36['post']['reqBody'], config?: T }) =>
              fetch<Methods36['post']['resBody'], BasicHeaders, Methods36['post']['status']>(prefix, prefix2, POST, option).json().then(r => r.body),
            $path: () => `${prefix}${prefix2}`
          }
        },
        post: (option: { body: Methods35['post']['reqBody'], config?: T }) =>
          fetch<Methods35['post']['resBody'], BasicHeaders, Methods35['post']['status']>(prefix, PATH29, POST, option).json(),
        $post: (option: { body: Methods35['post']['reqBody'], config?: T }) =>
          fetch<Methods35['post']['resBody'], BasicHeaders, Methods35['post']['status']>(prefix, PATH29, POST, option).json().then(r => r.body),
        $path: () => `${prefix}${PATH29}`
      },
      monitors_csv: {
        get: (option?: { query?: Methods37['get']['query'], config?: T }) =>
          fetch<void, BasicHeaders, Methods37['get']['status']>(prefix, PATH30, GET, option).send(),
        $get: (option?: { query?: Methods37['get']['query'], config?: T }) =>
          fetch<void, BasicHeaders, Methods37['get']['status']>(prefix, PATH30, GET, option).send().then(r => r.body),
        $path: (option?: { method?: 'get'; query: Methods37['get']['query'] }) =>
          `${prefix}${PATH30}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
      },
      get: (option?: { query?: Methods32['get']['query'], config?: T }) =>
        fetch<Methods32['get']['resBody'], BasicHeaders, Methods32['get']['status']>(prefix, PATH27, GET, option).json(),
      $get: (option?: { query?: Methods32['get']['query'], config?: T }) =>
        fetch<Methods32['get']['resBody'], BasicHeaders, Methods32['get']['status']>(prefix, PATH27, GET, option).json().then(r => r.body),
      $path: (option?: { method?: 'get'; query: Methods32['get']['query'] }) =>
        `${prefix}${PATH27}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
    },
    notices: {
      _id: (val1: number) => {
        const prefix1 = `${PATH31}/${val1}`

        return {
          get: (option?: { config?: T }) =>
            fetch<Methods39['get']['resBody'], BasicHeaders, Methods39['get']['status']>(prefix, prefix1, GET, option).json(),
          $get: (option?: { config?: T }) =>
            fetch<Methods39['get']['resBody'], BasicHeaders, Methods39['get']['status']>(prefix, prefix1, GET, option).json().then(r => r.body),
          put: (option: { body: Methods39['put']['reqBody'], config?: T }) =>
            fetch<Methods39['put']['resBody'], BasicHeaders, Methods39['put']['status']>(prefix, prefix1, PUT, option).json(),
          $put: (option: { body: Methods39['put']['reqBody'], config?: T }) =>
            fetch<Methods39['put']['resBody'], BasicHeaders, Methods39['put']['status']>(prefix, prefix1, PUT, option).json().then(r => r.body),
          delete: (option?: { config?: T }) =>
            fetch<Methods39['delete']['resBody'], BasicHeaders, Methods39['delete']['status']>(prefix, prefix1, DELETE, option).json(),
          $delete: (option?: { config?: T }) =>
            fetch<Methods39['delete']['resBody'], BasicHeaders, Methods39['delete']['status']>(prefix, prefix1, DELETE, option).json().then(r => r.body),
          $path: () => `${prefix}${prefix1}`
        }
      },
      post: (option: { body: Methods38['post']['reqBody'], config?: T }) =>
        fetch<Methods38['post']['resBody'], BasicHeaders, Methods38['post']['status']>(prefix, PATH31, POST, option).json(),
      $post: (option: { body: Methods38['post']['reqBody'], config?: T }) =>
        fetch<Methods38['post']['resBody'], BasicHeaders, Methods38['post']['status']>(prefix, PATH31, POST, option).json().then(r => r.body),
      get: (option?: { config?: T }) =>
        fetch<Methods38['get']['resBody'], BasicHeaders, Methods38['get']['status']>(prefix, PATH31, GET, option).json(),
      $get: (option?: { config?: T }) =>
        fetch<Methods38['get']['resBody'], BasicHeaders, Methods38['get']['status']>(prefix, PATH31, GET, option).json().then(r => r.body),
      $path: () => `${prefix}${PATH31}`
    },
    place: {
      get: (option: { query: Methods40['get']['query'], config?: T }) =>
        fetch<Methods40['get']['resBody'], BasicHeaders, Methods40['get']['status']>(prefix, PATH32, GET, option).json(),
      $get: (option: { query: Methods40['get']['query'], config?: T }) =>
        fetch<Methods40['get']['resBody'], BasicHeaders, Methods40['get']['status']>(prefix, PATH32, GET, option).json().then(r => r.body),
      $path: (option?: { method?: 'get'; query: Methods40['get']['query'] }) =>
        `${prefix}${PATH32}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
    },
    qlogs: {
      qlogs_csv: {
        get: (option?: { config?: T }) =>
          fetch<void, BasicHeaders, Methods42['get']['status']>(prefix, PATH34, GET, option).send(),
        $get: (option?: { config?: T }) =>
          fetch<void, BasicHeaders, Methods42['get']['status']>(prefix, PATH34, GET, option).send().then(r => r.body),
        $path: () => `${prefix}${PATH34}`
      },
      post: (option: { body: Methods41['post']['reqBody'], config?: T }) =>
        fetch<Methods41['post']['resBody'], BasicHeaders, Methods41['post']['status']>(prefix, PATH33, POST, option).json(),
      $post: (option: { body: Methods41['post']['reqBody'], config?: T }) =>
        fetch<Methods41['post']['resBody'], BasicHeaders, Methods41['post']['status']>(prefix, PATH33, POST, option).json().then(r => r.body),
      get: (option?: { config?: T }) =>
        fetch<Methods41['get']['resBody'], BasicHeaders, Methods41['get']['status']>(prefix, PATH33, GET, option).json(),
      $get: (option?: { config?: T }) =>
        fetch<Methods41['get']['resBody'], BasicHeaders, Methods41['get']['status']>(prefix, PATH33, GET, option).json().then(r => r.body),
      $path: () => `${prefix}${PATH33}`
    },
    question: {
      _question_id: (val1: number) => {
        const prefix1 = `${PATH35}/${val1}`

        return {
          get: (option?: { config?: T }) =>
            fetch<Methods44['get']['resBody'], BasicHeaders, Methods44['get']['status']>(prefix, prefix1, GET, option).json(),
          $get: (option?: { config?: T }) =>
            fetch<Methods44['get']['resBody'], BasicHeaders, Methods44['get']['status']>(prefix, prefix1, GET, option).json().then(r => r.body),
          put: (option: { body: Methods44['put']['reqBody'], config?: T }) =>
            fetch<Methods44['put']['resBody'], BasicHeaders, Methods44['put']['status']>(prefix, prefix1, PUT, option).json(),
          $put: (option: { body: Methods44['put']['reqBody'], config?: T }) =>
            fetch<Methods44['put']['resBody'], BasicHeaders, Methods44['put']['status']>(prefix, prefix1, PUT, option).json().then(r => r.body),
          delete: (option?: { config?: T }) =>
            fetch<Methods44['delete']['resBody'], BasicHeaders, Methods44['delete']['status']>(prefix, prefix1, DELETE, option).json(),
          $delete: (option?: { config?: T }) =>
            fetch<Methods44['delete']['resBody'], BasicHeaders, Methods44['delete']['status']>(prefix, prefix1, DELETE, option).json().then(r => r.body),
          $path: () => `${prefix}${prefix1}`
        }
      },
      get: (option: { query: Methods43['get']['query'], config?: T }) =>
        fetch<Methods43['get']['resBody'], BasicHeaders, Methods43['get']['status']>(prefix, PATH35, GET, option).json(),
      $get: (option: { query: Methods43['get']['query'], config?: T }) =>
        fetch<Methods43['get']['resBody'], BasicHeaders, Methods43['get']['status']>(prefix, PATH35, GET, option).json().then(r => r.body),
      post: (option: { body: Methods43['post']['reqBody'], config?: T }) =>
        fetch<Methods43['post']['resBody'], BasicHeaders, Methods43['post']['status']>(prefix, PATH35, POST, option).json(),
      $post: (option: { body: Methods43['post']['reqBody'], config?: T }) =>
        fetch<Methods43['post']['resBody'], BasicHeaders, Methods43['post']['status']>(prefix, PATH35, POST, option).json().then(r => r.body),
      $path: (option?: { method?: 'get'; query: Methods43['get']['query'] }) =>
        `${prefix}${PATH35}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
    },
    question_answer: {
      _id: (val1: number) => {
        const prefix1 = `${PATH36}/${val1}`

        return {
          put: (option: { body: Methods45['put']['reqBody'], config?: T }) =>
            fetch<Methods45['put']['resBody'], BasicHeaders, Methods45['put']['status']>(prefix, prefix1, PUT, option).json(),
          $put: (option: { body: Methods45['put']['reqBody'], config?: T }) =>
            fetch<Methods45['put']['resBody'], BasicHeaders, Methods45['put']['status']>(prefix, prefix1, PUT, option).json().then(r => r.body),
          $path: () => `${prefix}${prefix1}`
        }
      },
      upload_image: {
        post: (option: { body: Methods46['post']['reqBody'], config?: T }) =>
          fetch<Methods46['post']['resBody'], BasicHeaders, Methods46['post']['status']>(prefix, PATH37, POST, option, 'FormData').text(),
        $post: (option: { body: Methods46['post']['reqBody'], config?: T }) =>
          fetch<Methods46['post']['resBody'], BasicHeaders, Methods46['post']['status']>(prefix, PATH37, POST, option, 'FormData').text().then(r => r.body),
        $path: () => `${prefix}${PATH37}`
      }
    },
    questionnaire: {
      _id_number: (val1: number) => {
        const prefix1 = `${PATH38}/${val1}`

        return {
          answers_csv: {
            get: (option?: { config?: T }) =>
              fetch<void, BasicHeaders, Methods49['get']['status']>(prefix, `${prefix1}${PATH39}`, GET, option).send(),
            $get: (option?: { config?: T }) =>
              fetch<void, BasicHeaders, Methods49['get']['status']>(prefix, `${prefix1}${PATH39}`, GET, option).send().then(r => r.body),
            $path: () => `${prefix}${prefix1}${PATH39}`
          },
          copy: {
            post: (option?: { config?: T }) =>
              fetch<Methods50['post']['resBody'], BasicHeaders, Methods50['post']['status']>(prefix, `${prefix1}${PATH40}`, POST, option).json(),
            $post: (option?: { config?: T }) =>
              fetch<Methods50['post']['resBody'], BasicHeaders, Methods50['post']['status']>(prefix, `${prefix1}${PATH40}`, POST, option).json().then(r => r.body),
            $path: () => `${prefix}${prefix1}${PATH40}`
          },
          get: (option?: { config?: T }) =>
            fetch<Methods48['get']['resBody'], BasicHeaders, Methods48['get']['status']>(prefix, prefix1, GET, option).json(),
          $get: (option?: { config?: T }) =>
            fetch<Methods48['get']['resBody'], BasicHeaders, Methods48['get']['status']>(prefix, prefix1, GET, option).json().then(r => r.body),
          put: (option: { body: Methods48['put']['reqBody'], config?: T }) =>
            fetch<Methods48['put']['resBody'], BasicHeaders, Methods48['put']['status']>(prefix, prefix1, PUT, option).json(),
          $put: (option: { body: Methods48['put']['reqBody'], config?: T }) =>
            fetch<Methods48['put']['resBody'], BasicHeaders, Methods48['put']['status']>(prefix, prefix1, PUT, option).json().then(r => r.body),
          delete: (option?: { config?: T }) =>
            fetch<Methods48['delete']['resBody'], BasicHeaders, Methods48['delete']['status']>(prefix, prefix1, DELETE, option).json(),
          $delete: (option?: { config?: T }) =>
            fetch<Methods48['delete']['resBody'], BasicHeaders, Methods48['delete']['status']>(prefix, prefix1, DELETE, option).json().then(r => r.body),
          $path: () => `${prefix}${prefix1}`
        }
      },
      _id_string: (val1: string) => {
        const prefix1 = `${PATH38}/${val1}`

        return {
          _answerId: (val2: string) => {
            const prefix2 = `${prefix1}/${val2}`

            return {
              get: (option: { query: Methods51['get']['query'], config?: T }) =>
                fetch<Methods51['get']['resBody'], BasicHeaders, Methods51['get']['status']>(prefix, prefix2, GET, option).json(),
              $get: (option: { query: Methods51['get']['query'], config?: T }) =>
                fetch<Methods51['get']['resBody'], BasicHeaders, Methods51['get']['status']>(prefix, prefix2, GET, option).json().then(r => r.body),
              $path: (option?: { method?: 'get'; query: Methods51['get']['query'] }) =>
                `${prefix}${prefix2}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
            }
          }
        }
      },
      additional_issue: {
        _id: (val2: number) => {
          const prefix2 = `${PATH41}/${val2}`

          return {
            put: (option?: { config?: T }) =>
              fetch<Methods52['put']['resBody'], BasicHeaders, Methods52['put']['status']>(prefix, prefix2, PUT, option).json(),
            $put: (option?: { config?: T }) =>
              fetch<Methods52['put']['resBody'], BasicHeaders, Methods52['put']['status']>(prefix, prefix2, PUT, option).json().then(r => r.body),
            $path: () => `${prefix}${prefix2}`
          }
        }
      },
      count_target: {
        _id: (val2: number) => {
          const prefix2 = `${PATH42}/${val2}`

          return {
            get: (option?: { config?: T }) =>
              fetch<Methods53['get']['resBody'], BasicHeaders, Methods53['get']['status']>(prefix, prefix2, GET, option).json(),
            $get: (option?: { config?: T }) =>
              fetch<Methods53['get']['resBody'], BasicHeaders, Methods53['get']['status']>(prefix, prefix2, GET, option).json().then(r => r.body),
            $path: () => `${prefix}${prefix2}`
          }
        }
      },
      fixed: {
        _questionnaireId: (val2: string) => {
          const prefix2 = `${PATH43}/${val2}`

          return {
            get: (option?: { config?: T }) =>
              fetch<Methods54['get']['resBody'], BasicHeaders, Methods54['get']['status']>(prefix, prefix2, GET, option).json(),
            $get: (option?: { config?: T }) =>
              fetch<Methods54['get']['resBody'], BasicHeaders, Methods54['get']['status']>(prefix, prefix2, GET, option).json().then(r => r.body),
            $path: () => `${prefix}${prefix2}`
          }
        }
      },
      fixed_preview: {
        _questionnaireId: (val2: string) => {
          const prefix2 = `${PATH44}/${val2}`

          return {
            get: (option: { query: Methods55['get']['query'], config?: T }) =>
              fetch<Methods55['get']['resBody'], BasicHeaders, Methods55['get']['status']>(prefix, prefix2, GET, option).json(),
            $get: (option: { query: Methods55['get']['query'], config?: T }) =>
              fetch<Methods55['get']['resBody'], BasicHeaders, Methods55['get']['status']>(prefix, prefix2, GET, option).json().then(r => r.body),
            $path: (option?: { method?: 'get'; query: Methods55['get']['query'] }) =>
              `${prefix}${prefix2}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
          }
        }
      },
      issue: {
        _id: (val2: number) => {
          const prefix2 = `${PATH45}/${val2}`

          return {
            put: (option?: { config?: T }) =>
              fetch<Methods56['put']['resBody'], BasicHeaders, Methods56['put']['status']>(prefix, prefix2, PUT, option).json(),
            $put: (option?: { config?: T }) =>
              fetch<Methods56['put']['resBody'], BasicHeaders, Methods56['put']['status']>(prefix, prefix2, PUT, option).json().then(r => r.body),
            $path: () => `${prefix}${prefix2}`
          }
        }
      },
      preview: {
        _questionnaireId: (val2: string) => {
          const prefix2 = `${PATH46}/${val2}`

          return {
            get: (option: { query: Methods57['get']['query'], config?: T }) =>
              fetch<Methods57['get']['resBody'], BasicHeaders, Methods57['get']['status']>(prefix, prefix2, GET, option).json(),
            $get: (option: { query: Methods57['get']['query'], config?: T }) =>
              fetch<Methods57['get']['resBody'], BasicHeaders, Methods57['get']['status']>(prefix, prefix2, GET, option).json().then(r => r.body),
            $path: (option?: { method?: 'get'; query: Methods57['get']['query'] }) =>
              `${prefix}${prefix2}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
          }
        }
      },
      preview_url: {
        _id: (val2: number) => {
          const prefix2 = `${PATH47}/${val2}`

          return {
            get: (option?: { config?: T }) =>
              fetch<Methods58['get']['resBody'], BasicHeaders, Methods58['get']['status']>(prefix, prefix2, GET, option).text(),
            $get: (option?: { config?: T }) =>
              fetch<Methods58['get']['resBody'], BasicHeaders, Methods58['get']['status']>(prefix, prefix2, GET, option).text().then(r => r.body),
            $path: () => `${prefix}${prefix2}`
          }
        }
      },
      get: (option?: { query?: Methods47['get']['query'], config?: T }) =>
        fetch<Methods47['get']['resBody'], BasicHeaders, Methods47['get']['status']>(prefix, PATH38, GET, option).json(),
      $get: (option?: { query?: Methods47['get']['query'], config?: T }) =>
        fetch<Methods47['get']['resBody'], BasicHeaders, Methods47['get']['status']>(prefix, PATH38, GET, option).json().then(r => r.body),
      post: (option: { body: Methods47['post']['reqBody'], config?: T }) =>
        fetch<Methods47['post']['resBody'], BasicHeaders, Methods47['post']['status']>(prefix, PATH38, POST, option).json(),
      $post: (option: { body: Methods47['post']['reqBody'], config?: T }) =>
        fetch<Methods47['post']['resBody'], BasicHeaders, Methods47['post']['status']>(prefix, PATH38, POST, option).json().then(r => r.body),
      $path: (option?: { method?: 'get'; query: Methods47['get']['query'] }) =>
        `${prefix}${PATH38}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
    },
    questionnaire_answer: {
      _id: (val1: number) => {
        const prefix1 = `${PATH48}/${val1}`

        return {
          get: (option?: { config?: T }) =>
            fetch<Methods60['get']['resBody'], BasicHeaders, Methods60['get']['status']>(prefix, prefix1, GET, option).json(),
          $get: (option?: { config?: T }) =>
            fetch<Methods60['get']['resBody'], BasicHeaders, Methods60['get']['status']>(prefix, prefix1, GET, option).json().then(r => r.body),
          put: (option: { body: Methods60['put']['reqBody'], config?: T }) =>
            fetch<Methods60['put']['resBody'], BasicHeaders, Methods60['put']['status']>(prefix, prefix1, PUT, option).json(),
          $put: (option: { body: Methods60['put']['reqBody'], config?: T }) =>
            fetch<Methods60['put']['resBody'], BasicHeaders, Methods60['put']['status']>(prefix, prefix1, PUT, option).json().then(r => r.body),
          $path: () => `${prefix}${prefix1}`
        }
      },
      _questionnaireId: (val1: string) => {
        const prefix1 = `${PATH48}/${val1}`

        return {
          _answerId: (val2: string) => {
            const prefix2 = `${prefix1}/${val2}`

            return {
              put: (option: { body: Methods61['put']['reqBody'], query: Methods61['put']['query'], config?: T }) =>
                fetch<Methods61['put']['resBody'], BasicHeaders, Methods61['put']['status']>(prefix, prefix2, PUT, option).json(),
              $put: (option: { body: Methods61['put']['reqBody'], query: Methods61['put']['query'], config?: T }) =>
                fetch<Methods61['put']['resBody'], BasicHeaders, Methods61['put']['status']>(prefix, prefix2, PUT, option).json().then(r => r.body),
              $path: (option?: { method: 'put'; query: Methods61['put']['query'] }) =>
                `${prefix}${prefix2}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
            }
          }
        }
      },
      internal: {
        _monitorId: (val2: string) => {
          const prefix2 = `${PATH49}/${val2}`

          return {
            get: (option?: { config?: T }) =>
              fetch<void, BasicHeaders, Methods62['get']['status']>(prefix, prefix2, GET, option).send(),
            $get: (option?: { config?: T }) =>
              fetch<void, BasicHeaders, Methods62['get']['status']>(prefix, prefix2, GET, option).send().then(r => r.body),
            $path: () => `${prefix}${prefix2}`
          }
        }
      },
      results_requests: {
        post: (option: { body: Methods63['post']['reqBody'], config?: T }) =>
          fetch<Methods63['post']['resBody'], BasicHeaders, Methods63['post']['status']>(prefix, PATH50, POST, option).json(),
        $post: (option: { body: Methods63['post']['reqBody'], config?: T }) =>
          fetch<Methods63['post']['resBody'], BasicHeaders, Methods63['post']['status']>(prefix, PATH50, POST, option).json().then(r => r.body),
        $path: () => `${prefix}${PATH50}`
      },
      get: (option?: { query?: Methods59['get']['query'], config?: T }) =>
        fetch<Methods59['get']['resBody'], BasicHeaders, Methods59['get']['status']>(prefix, PATH48, GET, option).json(),
      $get: (option?: { query?: Methods59['get']['query'], config?: T }) =>
        fetch<Methods59['get']['resBody'], BasicHeaders, Methods59['get']['status']>(prefix, PATH48, GET, option).json().then(r => r.body),
      $path: (option?: { method?: 'get'; query: Methods59['get']['query'] }) =>
        `${prefix}${PATH48}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
    },
    questionnaire_page: {
      _page_id: (val1: number) => {
        const prefix1 = `${PATH51}/${val1}`

        return {
          get: (option?: { config?: T }) =>
            fetch<Methods65['get']['resBody'], BasicHeaders, Methods65['get']['status']>(prefix, prefix1, GET, option).json(),
          $get: (option?: { config?: T }) =>
            fetch<Methods65['get']['resBody'], BasicHeaders, Methods65['get']['status']>(prefix, prefix1, GET, option).json().then(r => r.body),
          put: (option: { body: Methods65['put']['reqBody'], config?: T }) =>
            fetch<Methods65['put']['resBody'], BasicHeaders, Methods65['put']['status']>(prefix, prefix1, PUT, option).json(),
          $put: (option: { body: Methods65['put']['reqBody'], config?: T }) =>
            fetch<Methods65['put']['resBody'], BasicHeaders, Methods65['put']['status']>(prefix, prefix1, PUT, option).json().then(r => r.body),
          delete: (option?: { config?: T }) =>
            fetch<Methods65['delete']['resBody'], BasicHeaders, Methods65['delete']['status']>(prefix, prefix1, DELETE, option).json(),
          $delete: (option?: { config?: T }) =>
            fetch<Methods65['delete']['resBody'], BasicHeaders, Methods65['delete']['status']>(prefix, prefix1, DELETE, option).json().then(r => r.body),
          $path: () => `${prefix}${prefix1}`
        }
      },
      get: (option: { query: Methods64['get']['query'], config?: T }) =>
        fetch<Methods64['get']['resBody'], BasicHeaders, Methods64['get']['status']>(prefix, PATH51, GET, option).json(),
      $get: (option: { query: Methods64['get']['query'], config?: T }) =>
        fetch<Methods64['get']['resBody'], BasicHeaders, Methods64['get']['status']>(prefix, PATH51, GET, option).json().then(r => r.body),
      post: (option: { body: Methods64['post']['reqBody'], config?: T }) =>
        fetch<Methods64['post']['resBody'], BasicHeaders, Methods64['post']['status']>(prefix, PATH51, POST, option).json(),
      $post: (option: { body: Methods64['post']['reqBody'], config?: T }) =>
        fetch<Methods64['post']['resBody'], BasicHeaders, Methods64['post']['status']>(prefix, PATH51, POST, option).json().then(r => r.body),
      $path: (option?: { method?: 'get'; query: Methods64['get']['query'] }) =>
        `${prefix}${PATH51}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
    },
    receipts: {
      _id: (val1: number) => {
        const prefix1 = `${PATH52}/${val1}`

        return {
          get: (option: { query: Methods67['get']['query'], config?: T }) =>
            fetch<Methods67['get']['resBody'], BasicHeaders, Methods67['get']['status']>(prefix, prefix1, GET, option).json(),
          $get: (option: { query: Methods67['get']['query'], config?: T }) =>
            fetch<Methods67['get']['resBody'], BasicHeaders, Methods67['get']['status']>(prefix, prefix1, GET, option).json().then(r => r.body),
          put: (option: { body: Methods67['put']['reqBody'], config?: T }) =>
            fetch<Methods67['put']['resBody'], BasicHeaders, Methods67['put']['status']>(prefix, prefix1, PUT, option).json(),
          $put: (option: { body: Methods67['put']['reqBody'], config?: T }) =>
            fetch<Methods67['put']['resBody'], BasicHeaders, Methods67['put']['status']>(prefix, prefix1, PUT, option).json().then(r => r.body),
          $path: (option?: { method?: 'get'; query: Methods67['get']['query'] }) =>
            `${prefix}${prefix1}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
        }
      },
      bigquery_csv: {
        get: (option?: { config?: T }) =>
          fetch<void, BasicHeaders, Methods68['get']['status']>(prefix, PATH53, GET, option).send(),
        $get: (option?: { config?: T }) =>
          fetch<void, BasicHeaders, Methods68['get']['status']>(prefix, PATH53, GET, option).send().then(r => r.body),
        $path: () => `${prefix}${PATH53}`
      },
      checkDuplicated: {
        post: (option: { body: Methods69['post']['reqBody'], config?: T }) =>
          fetch<Methods69['post']['resBody'], BasicHeaders, Methods69['post']['status']>(prefix, PATH54, POST, option).json(),
        $post: (option: { body: Methods69['post']['reqBody'], config?: T }) =>
          fetch<Methods69['post']['resBody'], BasicHeaders, Methods69['post']['status']>(prefix, PATH54, POST, option).json().then(r => r.body),
        $path: () => `${prefix}${PATH54}`
      },
      chobirich: {
        remaind_count: {
          get: (option: { query: Methods70['get']['query'], config?: T }) =>
            fetch<void, BasicHeaders, Methods70['get']['status']>(prefix, PATH55, GET, option).send(),
          $get: (option: { query: Methods70['get']['query'], config?: T }) =>
            fetch<void, BasicHeaders, Methods70['get']['status']>(prefix, PATH55, GET, option).send().then(r => r.body),
          $path: (option?: { method?: 'get'; query: Methods70['get']['query'] }) =>
            `${prefix}${PATH55}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
        },
        upload_image: {
          post: (option: { body: Methods71['post']['reqBody'], config?: T }) =>
            fetch<Methods71['post']['resBody'], BasicHeaders, Methods71['post']['status']>(prefix, PATH56, POST, option, 'FormData').text(),
          $post: (option: { body: Methods71['post']['reqBody'], config?: T }) =>
            fetch<Methods71['post']['resBody'], BasicHeaders, Methods71['post']['status']>(prefix, PATH56, POST, option, 'FormData').text().then(r => r.body),
          $path: () => `${prefix}${PATH56}`
        }
      },
      contributers: {
        get: (option: { query: Methods72['get']['query'], config?: T }) =>
          fetch<Methods72['get']['resBody'], BasicHeaders, Methods72['get']['status']>(prefix, PATH57, GET, option).json(),
        $get: (option: { query: Methods72['get']['query'], config?: T }) =>
          fetch<Methods72['get']['resBody'], BasicHeaders, Methods72['get']['status']>(prefix, PATH57, GET, option).json().then(r => r.body),
        $path: (option?: { method?: 'get'; query: Methods72['get']['query'] }) =>
          `${prefix}${PATH57}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
      },
      contributers_csv: {
        get: (option?: { config?: T }) =>
          fetch<void, BasicHeaders, Methods73['get']['status']>(prefix, PATH58, GET, option).send(),
        $get: (option?: { config?: T }) =>
          fetch<void, BasicHeaders, Methods73['get']['status']>(prefix, PATH58, GET, option).send().then(r => r.body),
        $path: () => `${prefix}${PATH58}`
      },
      internal: {
        remained_count: {
          _monitorId: (val3: string) => {
            const prefix3 = `${PATH59}/${val3}`

            return {
              get: (option?: { config?: T }) =>
                fetch<void, BasicHeaders, Methods74['get']['status']>(prefix, prefix3, GET, option).send(),
              $get: (option?: { config?: T }) =>
                fetch<void, BasicHeaders, Methods74['get']['status']>(prefix, prefix3, GET, option).send().then(r => r.body),
              $path: () => `${prefix}${prefix3}`
            }
          }
        }
      },
      is_existing_image_id: {
        _imageId: (val2: string) => {
          const prefix2 = `${PATH60}/${val2}`

          return {
            get: (option?: { config?: T }) =>
              fetch<void, BasicHeaders, Methods75['get']['status']>(prefix, prefix2, GET, option).send(),
            $get: (option?: { config?: T }) =>
              fetch<void, BasicHeaders, Methods75['get']['status']>(prefix, prefix2, GET, option).send().then(r => r.body),
            $path: () => `${prefix}${prefix2}`
          }
        }
      },
      mock_questionnaire: {
        _id: (val2: string) => {
          const prefix2 = `${PATH61}/${val2}`

          return {
            _questionnaireId: (val3: number) => {
              const prefix3 = `${prefix2}/${val3}`

              return {
                get: (option?: { config?: T }) =>
                  fetch<void, BasicHeaders, Methods76['get']['status']>(prefix, prefix3, GET, option).send(),
                $get: (option?: { config?: T }) =>
                  fetch<void, BasicHeaders, Methods76['get']['status']>(prefix, prefix3, GET, option).send().then(r => r.body),
                $path: () => `${prefix}${prefix3}`
              }
            }
          }
        }
      },
      results_requests: {
        post: (option: { body: Methods77['post']['reqBody'], config?: T }) =>
          fetch<Methods77['post']['resBody'], BasicHeaders, Methods77['post']['status']>(prefix, PATH62, POST, option).json(),
        $post: (option: { body: Methods77['post']['reqBody'], config?: T }) =>
          fetch<Methods77['post']['resBody'], BasicHeaders, Methods77['post']['status']>(prefix, PATH62, POST, option).json().then(r => r.body),
        get: (option?: { config?: T }) =>
          fetch<Methods77['get']['resBody'], BasicHeaders, Methods77['get']['status']>(prefix, PATH62, GET, option).json(),
        $get: (option?: { config?: T }) =>
          fetch<Methods77['get']['resBody'], BasicHeaders, Methods77['get']['status']>(prefix, PATH62, GET, option).json().then(r => r.body),
        $path: () => `${prefix}${PATH62}`
      },
      results_requests_by_ids: {
        get: (option?: { config?: T }) =>
          fetch<Methods78['get']['resBody'], BasicHeaders, Methods78['get']['status']>(prefix, PATH63, GET, option).json(),
        $get: (option?: { config?: T }) =>
          fetch<Methods78['get']['resBody'], BasicHeaders, Methods78['get']['status']>(prefix, PATH63, GET, option).json().then(r => r.body),
        $path: () => `${prefix}${PATH63}`
      },
      snapShot: {
        get: (option?: { config?: T }) =>
          fetch<Methods79['get']['resBody'], BasicHeaders, Methods79['get']['status']>(prefix, PATH64, GET, option).json(),
        $get: (option?: { config?: T }) =>
          fetch<Methods79['get']['resBody'], BasicHeaders, Methods79['get']['status']>(prefix, PATH64, GET, option).json().then(r => r.body),
        $path: () => `${prefix}${PATH64}`
      },
      summaries: {
        get: (option: { query: Methods80['get']['query'], config?: T }) =>
          fetch<Methods80['get']['resBody'], BasicHeaders, Methods80['get']['status']>(prefix, PATH65, GET, option).json(),
        $get: (option: { query: Methods80['get']['query'], config?: T }) =>
          fetch<Methods80['get']['resBody'], BasicHeaders, Methods80['get']['status']>(prefix, PATH65, GET, option).json().then(r => r.body),
        $path: (option?: { method?: 'get'; query: Methods80['get']['query'] }) =>
          `${prefix}${PATH65}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
      },
      post: (option: { body: Methods66['post']['reqBody'], config?: T }) =>
        fetch<Methods66['post']['resBody'], BasicHeaders, Methods66['post']['status']>(prefix, PATH52, POST, option).json(),
      $post: (option: { body: Methods66['post']['reqBody'], config?: T }) =>
        fetch<Methods66['post']['resBody'], BasicHeaders, Methods66['post']['status']>(prefix, PATH52, POST, option).json().then(r => r.body),
      get: (option: { query: Methods66['get']['query'], config?: T }) =>
        fetch<Methods66['get']['resBody'], BasicHeaders, Methods66['get']['status']>(prefix, PATH52, GET, option).json(),
      $get: (option: { query: Methods66['get']['query'], config?: T }) =>
        fetch<Methods66['get']['resBody'], BasicHeaders, Methods66['get']['status']>(prefix, PATH52, GET, option).json().then(r => r.body),
      $path: (option?: { method?: 'get'; query: Methods66['get']['query'] }) =>
        `${prefix}${PATH52}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
    },
    recommend: {
      get: (option: { query: Methods81['get']['query'], config?: T }) =>
        fetch<Methods81['get']['resBody'], BasicHeaders, Methods81['get']['status']>(prefix, PATH66, GET, option).json(),
      $get: (option: { query: Methods81['get']['query'], config?: T }) =>
        fetch<Methods81['get']['resBody'], BasicHeaders, Methods81['get']['status']>(prefix, PATH66, GET, option).json().then(r => r.body),
      $path: (option?: { method?: 'get'; query: Methods81['get']['query'] }) =>
        `${prefix}${PATH66}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
    },
    shops: {
      _id: (val1: string) => {
        const prefix1 = `${PATH67}/${val1}`

        return {
          get: (option?: { config?: T }) =>
            fetch<Methods83['get']['resBody'], BasicHeaders, Methods83['get']['status']>(prefix, prefix1, GET, option).json(),
          $get: (option?: { config?: T }) =>
            fetch<Methods83['get']['resBody'], BasicHeaders, Methods83['get']['status']>(prefix, prefix1, GET, option).json().then(r => r.body),
          put: (option: { body: Methods83['put']['reqBody'], config?: T }) =>
            fetch<Methods83['put']['resBody'], BasicHeaders, Methods83['put']['status']>(prefix, prefix1, PUT, option).json(),
          $put: (option: { body: Methods83['put']['reqBody'], config?: T }) =>
            fetch<Methods83['put']['resBody'], BasicHeaders, Methods83['put']['status']>(prefix, prefix1, PUT, option).json().then(r => r.body),
          $path: () => `${prefix}${prefix1}`
        }
      },
      post: (option: { body: Methods82['post']['reqBody'], config?: T }) =>
        fetch<Methods82['post']['resBody'], BasicHeaders, Methods82['post']['status']>(prefix, PATH67, POST, option).json(),
      $post: (option: { body: Methods82['post']['reqBody'], config?: T }) =>
        fetch<Methods82['post']['resBody'], BasicHeaders, Methods82['post']['status']>(prefix, PATH67, POST, option).json().then(r => r.body),
      get: (option: { query: Methods82['get']['query'], config?: T }) =>
        fetch<Methods82['get']['resBody'], BasicHeaders, Methods82['get']['status']>(prefix, PATH67, GET, option).json(),
      $get: (option: { query: Methods82['get']['query'], config?: T }) =>
        fetch<Methods82['get']['resBody'], BasicHeaders, Methods82['get']['status']>(prefix, PATH67, GET, option).json().then(r => r.body),
      $path: (option?: { method?: 'get'; query: Methods82['get']['query'] }) =>
        `${prefix}${PATH67}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
    },
    slogs: {
      slogs_csv: {
        get: (option?: { query?: Methods85['get']['query'], config?: T }) =>
          fetch<void, BasicHeaders, Methods85['get']['status']>(prefix, PATH69, GET, option).send(),
        $get: (option?: { query?: Methods85['get']['query'], config?: T }) =>
          fetch<void, BasicHeaders, Methods85['get']['status']>(prefix, PATH69, GET, option).send().then(r => r.body),
        $path: (option?: { method?: 'get'; query: Methods85['get']['query'] }) =>
          `${prefix}${PATH69}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
      },
      post: (option: { body: Methods84['post']['reqBody'], config?: T }) =>
        fetch<Methods84['post']['resBody'], BasicHeaders, Methods84['post']['status']>(prefix, PATH68, POST, option).json(),
      $post: (option: { body: Methods84['post']['reqBody'], config?: T }) =>
        fetch<Methods84['post']['resBody'], BasicHeaders, Methods84['post']['status']>(prefix, PATH68, POST, option).json().then(r => r.body),
      get: (option?: { query?: Methods84['get']['query'], config?: T }) =>
        fetch<Methods84['get']['resBody'], BasicHeaders, Methods84['get']['status']>(prefix, PATH68, GET, option).json(),
      $get: (option?: { query?: Methods84['get']['query'], config?: T }) =>
        fetch<Methods84['get']['resBody'], BasicHeaders, Methods84['get']['status']>(prefix, PATH68, GET, option).json().then(r => r.body),
      $path: (option?: { method?: 'get'; query: Methods84['get']['query'] }) =>
        `${prefix}${PATH68}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
    },
    special_offer_receipts: {
      _id: (val1: number) => {
        const prefix1 = `${PATH70}/${val1}`

        return {
          get: (option?: { config?: T }) =>
            fetch<Methods87['get']['resBody'], BasicHeaders, Methods87['get']['status']>(prefix, prefix1, GET, option).json(),
          $get: (option?: { config?: T }) =>
            fetch<Methods87['get']['resBody'], BasicHeaders, Methods87['get']['status']>(prefix, prefix1, GET, option).json().then(r => r.body),
          put: (option: { body: Methods87['put']['reqBody'], config?: T }) =>
            fetch<Methods87['put']['resBody'], BasicHeaders, Methods87['put']['status']>(prefix, prefix1, PUT, option).json(),
          $put: (option: { body: Methods87['put']['reqBody'], config?: T }) =>
            fetch<Methods87['put']['resBody'], BasicHeaders, Methods87['put']['status']>(prefix, prefix1, PUT, option).json().then(r => r.body),
          $path: () => `${prefix}${prefix1}`
        }
      },
      internal: {
        post: (option: { body: Methods88['post']['reqBody'], config?: T }) =>
          fetch<Methods88['post']['resBody'], BasicHeaders, Methods88['post']['status']>(prefix, PATH71, POST, option).json(),
        $post: (option: { body: Methods88['post']['reqBody'], config?: T }) =>
          fetch<Methods88['post']['resBody'], BasicHeaders, Methods88['post']['status']>(prefix, PATH71, POST, option).json().then(r => r.body),
        get: (option: { query: Methods88['get']['query'], config?: T }) =>
          fetch<Methods88['get']['resBody'], BasicHeaders, Methods88['get']['status']>(prefix, PATH71, GET, option).json(),
        $get: (option: { query: Methods88['get']['query'], config?: T }) =>
          fetch<Methods88['get']['resBody'], BasicHeaders, Methods88['get']['status']>(prefix, PATH71, GET, option).json().then(r => r.body),
        $path: (option?: { method?: 'get'; query: Methods88['get']['query'] }) =>
          `${prefix}${PATH71}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
      },
      internal_by_imported_at: {
        get: (option: { query: Methods89['get']['query'], config?: T }) =>
          fetch<Methods89['get']['resBody'], BasicHeaders, Methods89['get']['status']>(prefix, PATH72, GET, option).json(),
        $get: (option: { query: Methods89['get']['query'], config?: T }) =>
          fetch<Methods89['get']['resBody'], BasicHeaders, Methods89['get']['status']>(prefix, PATH72, GET, option).json().then(r => r.body),
        $path: (option?: { method?: 'get'; query: Methods89['get']['query'] }) =>
          `${prefix}${PATH72}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
      },
      get: (option?: { query?: Methods86['get']['query'], config?: T }) =>
        fetch<Methods86['get']['resBody'], BasicHeaders, Methods86['get']['status']>(prefix, PATH70, GET, option).json(),
      $get: (option?: { query?: Methods86['get']['query'], config?: T }) =>
        fetch<Methods86['get']['resBody'], BasicHeaders, Methods86['get']['status']>(prefix, PATH70, GET, option).json().then(r => r.body),
      $path: (option?: { method?: 'get'; query: Methods86['get']['query'] }) =>
        `${prefix}${PATH70}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
    },
    special_offers: {
      _id: (val1: string) => {
        const prefix1 = `${PATH73}/${val1}`

        return {
          get: (option?: { config?: T }) =>
            fetch<Methods91['get']['resBody'], BasicHeaders, Methods91['get']['status']>(prefix, prefix1, GET, option).json(),
          $get: (option?: { config?: T }) =>
            fetch<Methods91['get']['resBody'], BasicHeaders, Methods91['get']['status']>(prefix, prefix1, GET, option).json().then(r => r.body),
          put: (option: { body: Methods91['put']['reqBody'], config?: T }) =>
            fetch<Methods91['put']['resBody'], BasicHeaders, Methods91['put']['status']>(prefix, prefix1, PUT, option).json(),
          $put: (option: { body: Methods91['put']['reqBody'], config?: T }) =>
            fetch<Methods91['put']['resBody'], BasicHeaders, Methods91['put']['status']>(prefix, prefix1, PUT, option).json().then(r => r.body),
          $path: () => `${prefix}${prefix1}`
        }
      },
      internal: {
        post: (option: { body: Methods92['post']['reqBody'], config?: T }) =>
          fetch<Methods92['post']['resBody'], BasicHeaders, Methods92['post']['status']>(prefix, PATH74, POST, option).json(),
        $post: (option: { body: Methods92['post']['reqBody'], config?: T }) =>
          fetch<Methods92['post']['resBody'], BasicHeaders, Methods92['post']['status']>(prefix, PATH74, POST, option).json().then(r => r.body),
        $path: () => `${prefix}${PATH74}`
      },
      get: (option?: { query?: Methods90['get']['query'], config?: T }) =>
        fetch<Methods90['get']['resBody'], BasicHeaders, Methods90['get']['status']>(prefix, PATH73, GET, option).json(),
      $get: (option?: { query?: Methods90['get']['query'], config?: T }) =>
        fetch<Methods90['get']['resBody'], BasicHeaders, Methods90['get']['status']>(prefix, PATH73, GET, option).json().then(r => r.body),
      $path: (option?: { method?: 'get'; query: Methods90['get']['query'] }) =>
        `${prefix}${PATH73}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`
    },
    users: {
      _id: (val1: number) => {
        const prefix1 = `${PATH75}/${val1}`

        return {
          get: (option?: { config?: T }) =>
            fetch<Methods94['get']['resBody'], BasicHeaders, Methods94['get']['status']>(prefix, prefix1, GET, option).json(),
          $get: (option?: { config?: T }) =>
            fetch<Methods94['get']['resBody'], BasicHeaders, Methods94['get']['status']>(prefix, prefix1, GET, option).json().then(r => r.body),
          put: (option: { body: Methods94['put']['reqBody'], config?: T }) =>
            fetch<Methods94['put']['resBody'], BasicHeaders, Methods94['put']['status']>(prefix, prefix1, PUT, option).json(),
          $put: (option: { body: Methods94['put']['reqBody'], config?: T }) =>
            fetch<Methods94['put']['resBody'], BasicHeaders, Methods94['put']['status']>(prefix, prefix1, PUT, option).json().then(r => r.body),
          delete: (option?: { config?: T }) =>
            fetch<Methods94['delete']['resBody'], BasicHeaders, Methods94['delete']['status']>(prefix, prefix1, DELETE, option).json(),
          $delete: (option?: { config?: T }) =>
            fetch<Methods94['delete']['resBody'], BasicHeaders, Methods94['delete']['status']>(prefix, prefix1, DELETE, option).json().then(r => r.body),
          $path: () => `${prefix}${prefix1}`
        }
      },
      post: (option: { body: Methods93['post']['reqBody'], config?: T }) =>
        fetch<Methods93['post']['resBody'], BasicHeaders, Methods93['post']['status']>(prefix, PATH75, POST, option).json(),
      $post: (option: { body: Methods93['post']['reqBody'], config?: T }) =>
        fetch<Methods93['post']['resBody'], BasicHeaders, Methods93['post']['status']>(prefix, PATH75, POST, option).json().then(r => r.body),
      get: (option?: { config?: T }) =>
        fetch<Methods93['get']['resBody'], BasicHeaders, Methods93['get']['status']>(prefix, PATH75, GET, option).json(),
      $get: (option?: { config?: T }) =>
        fetch<Methods93['get']['resBody'], BasicHeaders, Methods93['get']['status']>(prefix, PATH75, GET, option).json().then(r => r.body),
      $path: () => `${prefix}${PATH75}`
    },
    /**
     * @returns The Health Check is successful
     */
    get: (option?: { config?: T }) =>
      fetch<Methods0['get']['resBody'], BasicHeaders, Methods0['get']['status']>(prefix, '', GET, option).json(),
    /**
     * @returns The Health Check is successful
     */
    $get: (option?: { config?: T }) =>
      fetch<Methods0['get']['resBody'], BasicHeaders, Methods0['get']['status']>(prefix, '', GET, option).json().then(r => r.body),
    $path: () => `${prefix}`
  }
}

// prettier-ignore
export type ApiInstance = ReturnType<typeof api>
// prettier-ignore
export default api
